import { Shield, Mail, Phone, AlertCircle } from "lucide-react";

export default function Footer() {
    return (
        <footer className="mt-24 bg-[var(--navy-deep)] text-white">
            <div className="container-x py-14 grid md:grid-cols-4 gap-8">
                <div className="md:col-span-1">
                    <div className="flex items-center gap-3 mb-4">
                        <img src="/logo-cucdanso.png" alt="" className="w-12 h-12 rounded-full bg-white p-1" />
                        <div>
                            <div className="font-heading font-bold">Cục Dân số</div>
                            <div className="text-[10px] text-[var(--gold)] tracking-widest">BỘ Y TẾ · VIỆT NAM</div>
                        </div>
                    </div>
                    <p className="text-sm text-slate-300 leading-relaxed">
                        Nền tảng thi trực tuyến tích hợp AI phục vụ truyền thông Luật Dân số quốc gia.
                    </p>
                </div>
                <div>
                    <div className="text-xs uppercase tracking-widest text-[var(--gold)] mb-3 font-semibold">Liên kết</div>
                    <ul className="space-y-2 text-sm text-slate-300">
                        <li className="hover:text-white cursor-pointer">Về Cục Dân số</li>
                        <li className="hover:text-white cursor-pointer">Luật Dân số (toàn văn)</li>
                        <li className="hover:text-white cursor-pointer">Thể lệ cuộc thi</li>
                        <li className="hover:text-white cursor-pointer">Hướng dẫn dự thi</li>
                    </ul>
                </div>
                <div>
                    <div className="text-xs uppercase tracking-widest text-[var(--gold)] mb-3 font-semibold">Hỗ trợ</div>
                    <ul className="space-y-2 text-sm text-slate-300">
                        <li className="flex items-center gap-2"><Phone className="w-3 h-3" /> 1800-XXXX (miễn phí)</li>
                        <li className="flex items-center gap-2"><Mail className="w-3 h-3" /> hotro@dansothi.gov.vn</li>
                        <li className="flex items-center gap-2"><AlertCircle className="w-3 h-3" /> Báo cáo gian lận</li>
                    </ul>
                </div>
                <div>
                    <div className="text-xs uppercase tracking-widest text-[var(--gold)] mb-3 font-semibold">Trụ sở</div>
                    <p className="text-sm text-slate-300 leading-relaxed">
                        138A Giảng Võ, Ba Đình, Hà Nội<br />
                        Việt Nam
                    </p>
                </div>
            </div>
            <div className="border-t border-white/10 py-5">
                <div className="container-x text-center text-xs text-slate-400">
                    © 2026 Cục Dân số — Bộ Y tế. Hệ thống Thi Trực Tuyến Tích Hợp AI · Phiên bản 1.0
                </div>
            </div>
        </footer>
    );
}
